<template lang="pug">
  .fp-app
    main.view
      router-view.main
</template>

<script>
import '@/shared/Sentry'
import Vue from 'vue'
export default {
  props: {
  },
  data () {
    return {

    }
  },
  created () {
    Vue.i18n.set(this.$route.query.lang || 'en')
  },
  mounted () {
    let token = localStorage.getItem('fp-store-query-token')
    if (token && !this.$route.query.token) {
      this.$store.commit('SET_TOKEN', token)
    }
    if (this.$route.query.token) {
      this.$store.commit('SET_TOKEN', this.$route.query.token)
      localStorage.setItem('fp-store-query-token', this.$route.query.token)
    }
    this.$store.dispatch('PACKAGES_ALL')
    window.addEventListener('message', (evt) => {
      if (evt.data && evt.data.op) {
        this.$store.dispatch(`IFRAME_${evt.data.op}`, evt.data.value)
      }
    }, false)
    this.$sendMessage(null, { state: 'ready' })
    setTimeout(() => {
      if (!this.$store.state.token) {
        this.$sendMessage('GET_TOKEN')
      }
    }, 500)
  },
  watch: {
    $route () {
      if (window !== window.parent) {
        this.$sendMessage('ROUTE_CHANGE', this.$route.path)
      }
    }
  }
}
</script>

<style lang="less">
.well {
  box-shadow: 1px 1px 5px #888888;
  background-color: white;
}
.fp-app {
  height: 100%;
  width: 100%;
  .view {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    transition:0.3s all;
    background-color: #fff;
    overflow: auto;
  }
}
</style>
